"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _animation = _interopRequireDefault(require("./style/animation"));

var _circle = _interopRequireDefault(require("./style/circle"));

var _text = _interopRequireDefault(require("./style/text"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _root = _interopRequireDefault(require("./style/root"));

var _wrapper = _interopRequireDefault(require("./style/wrapper"));

var _svg = _interopRequireDefault(require("./style/svg"));

var Preloader = function Preloader(_ref) {
  var className = _ref.className,
      label = _ref.label,
      children = _ref.children,
      theme = _ref.theme,
      style = _ref.style,
      center = _ref.center,
      small = _ref.small,
      xSmall = _ref.xSmall,
      large = _ref.large,
      inline = _ref.inline,
      delay = _ref.delay;
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [style]);
  var childrenLabel = '';

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!isNaN(delay) && delay > 0) {
      setVisible(false);
      var show = setTimeout(function () {
        return setVisible(true);
      }, delay);
      return function () {
        return clearTimeout(show);
      };
    }
  }, [delay]);

  if (label) {
    childrenLabel = _react["default"].createElement(_text["default"], {
      theme: memoTheme
    }, label);
  } else if (children) {
    childrenLabel = _react["default"].createElement(_text["default"], {
      theme: memoTheme
    }, children);
  }

  var _useMemo = (0, _react.useMemo)(function () {
    var palette = theme.palette;

    if (xSmall) {
      return [palette.tlNormal, palette.tlNormal];
    } else if (small) {
      return [palette.gutter * 3 + 'px', palette.gutter * 3 + 'px'];
    } else if (large) {
      return [palette.gutter * 6 + 'px', palette.gutter * 6 + 'px'];
    } else {
      return [theme.width, theme.height];
    }
  }, [small, xSmall, large]),
      _useMemo2 = (0, _slicedToArray2["default"])(_useMemo, 2),
      width = _useMemo2[0],
      height = _useMemo2[1];

  return visible ? _react["default"].createElement(_root["default"], {
    theme: memoTheme,
    center: center,
    inline: inline,
    className: className,
    "data-qa-node": "preloader"
  }, _react["default"].createElement(_wrapper["default"], {
    height: height
  }, _react["default"].createElement(_animation["default"], {
    width: width,
    height: height
  }, _react["default"].createElement(_svg["default"], {
    viewBox: "26 26 52 52"
  }, _react["default"].createElement(_circle["default"], {
    theme: memoTheme,
    cx: "52px",
    cy: "52px",
    r: "20px",
    fill: "none",
    strokeWidth: "4px"
  })))), childrenLabel) : null;
};

Preloader.defaultProps = {
  label: null,
  small: false,
  xSmall: false,
  large: false,
  inline: false,
  center: false,
  delay: 0
};
Preloader.propTypes = {
  label: _propTypes["default"].string,
  small: _propTypes["default"].bool,
  xSmall: _propTypes["default"].bool,
  large: _propTypes["default"].bool,
  inline: _propTypes["default"].bool,
  center: _propTypes["default"].bool,
  delay: _propTypes["default"].number,
  className: _propTypes["default"].string,
  children: _propTypes["default"].any,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default block
     */
    display: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    circleColor: _propTypes["default"].string,

    /**
     * @default palette.tInactive
     */
    color: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default palette.tlNormal
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default ${palette.gutter}px 0
     */
    padding: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter * 4 + 'px'
     */
    height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter * 4 + 'px'
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    top: _propTypes["default"].string,

    /**
     * @default auto
     */
    left: _propTypes["default"].string,

    /**
     * @default none
     */
    transform: _propTypes["default"].string,

    /**
     * @default relative
     */
    position: _propTypes["default"].string
  })
};
var _default = Preloader;
exports["default"] = _default;